import dayjs from 'dayjs'
import type { AllFilters } from '../NewDashboard/hooks/utils'

export const ADD_TODO_HASH_ROUTE = 'add-todo'

export const initialFiltersValue: AllFilters = {
  rangePicker: [dayjs(), dayjs()],
  residents: [],
  categories: [],
  status: [],
  categoryItems: [],
  search: ''
}
